import React from 'react';
import { Link } from 'react-router-dom';
interface NavItem {
  label: string;
  href: string;
  key: 'beef' | 'pork' | 'chicken';
}
const sections: NavItem[] = [{
  label: 'Beef',
  href: '/market-iq/beef',
  key: 'beef'
}, {
  label: 'Pork',
  href: '/market-iq/pork',
  key: 'pork'
}, {
  label: 'Chicken',
  href: '/market-iq/chicken',
  key: 'chicken'
}];
export function MarketIQNav({
  current
}: {
  current: 'beef' | 'pork' | 'chicken';
}) {
  return <div className="my-6 py-3 px-4 bg-gray-50 border-y border-gray-200" data-id="element-206">
      <div className="flex items-center justify-center gap-1" data-id="element-207">
        {sections.map(section => {
        const isActive = section.key === current;
        return isActive ? <span key={section.key} className="px-5 py-2 text-sm font-semibold text-white bg-[#002f5f] rounded-sm tracking-wide" data-id="element-208">
              {section.label}
            </span> : <Link key={section.key} to={section.href} className="px-5 py-2 text-sm font-medium text-[#002f5f] hover:bg-gray-200 rounded-sm transition-colors tracking-wide" data-id="element-209">
              {section.label}
            </Link>;
      })}
      </div>
    </div>;
}